import { ReactElement } from 'react';

const TelegramIcon = (props: TClassNameProps): ReactElement => (
	<svg width="24" height="25" viewBox="0 0 24 25" fill="none" {...props}>
		<path
			d="M20.2949 4.91237C20.2949 4.91237 22.1451 4.19287 21.9909 5.94023C21.9395 6.65973 21.4769 9.17798 21.1172 11.9018L19.8838 19.9705C19.8838 19.9705 19.781 21.1525 18.8559 21.3581C17.9308 21.5637 16.5432 20.6386 16.2863 20.433C16.0807 20.2789 12.4318 17.9662 11.147 16.8355C10.7872 16.5272 10.3761 15.9105 11.1984 15.191L16.5946 10.0517C17.2113 9.43495 17.828 7.99595 15.2584 9.74331L8.06339 14.6256C8.06339 14.6256 7.2411 15.1396 5.69931 14.677L2.35877 13.6492C2.35877 13.6492 1.12534 12.8783 3.23245 12.1074C8.37174 9.69191 14.6931 7.22505 20.2949 4.91237Z"
			fill="currentColor"
		/>
	</svg>
);

export default TelegramIcon;
